import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ScreenshotVisualizer from './components/ScreenshotVisualizer'
import { useAppStore } from './stores/appStore'

// Dedicated app entry used only for automated screenshots.
// Intentionally minimal: no global CSS imports, no i18n bootstrapping,
// just enough to initialize state from the URL and render the bed scene
// via ScreenshotVisualizer (canvas + Scene only, no UI).

const queryClient = new QueryClient()

function ScreenshotContent() {
  const { initializeFromURL } = useAppStore()

  useEffect(() => {
    // Initialize store from current URL (market/lang/bed/config, etc.)
    initializeFromURL()

    // Force noUI semantics for the /screenshot entrypoint so URL reflects intent.
    const url = new URL(window.location.href)
    if (!url.searchParams.has('noUI')) {
      url.searchParams.set('noUI', 'true')
      window.history.replaceState(null, '', url.toString())
    }
  }, [initializeFromURL])

  return <ScreenshotVisualizer />
}

export default function ScreenshotApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <ScreenshotContent />
    </QueryClientProvider>
  )
}

